var render = function render(){var _vm=this,_c=_vm._self._c;return _c('group-form',{attrs:{"type":_vm.type,"group":_vm.newGroup}})
}
var staticRenderFns = []

export { render, staticRenderFns }